<template>
    <a class="cw-button-hollow cw-button-hollow-tertiary uk-width-1-1" @click.prevent="handleClick">
    <span class="uk-flex uk-flex-middle uk-flex-center">
        <BaseIcon height="20" stroke-width="2" width="20">
            <IconListDetails />
        </BaseIcon>
        &nbsp;Playset Library
    </span>
    </a>
</template>

<script setup>
import BaseIcon from '../ui/BaseIcon'
import {useChooserStore} from "../../stores/ChooserStore";
import IconListDetails from "../icons/IconListDetails.vue";
import {storeToRefs} from "pinia";

const props = defineProps({
    productLineId: Number
})

const chooserStore = useChooserStore();

const {
    selectedProductLine
} = storeToRefs(chooserStore)

async function handleClick() {
    await chooserStore.resetSelections()

    selectedProductLine.value = props.productLineId

    window.location.href = '/chooser';
}
</script>
